import React, { useState, useContext } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import TopNav from '../nav/TopNav';
import AddressContext from '../../context/address/addressContext';
import styled from 'styled-components';
import ShippingAddressLogged from './ShippingAddressLogged';

const StyledBurger = styled.div`
  input[type='email'],
  input[type='text'],
  select {
    padding: 3px 1rem;
    color: #fff;
    background: none;
    outline: none;
    border-radius: 0.8rem;
    box-shadow: none;
    border: 1px solid #fff;
  }
  input[type='email']:focus,
  input[type='text']:focus {
    // background: #000;
    outline: none;
    box-shadow: none;
  }
  // input[type='email']:focus,
  // input[type='text']:focus,
  // input[type='password']:focus {
  //   border-bottom: 1px solid #000;
  // }
`;

const AddNewAddress = () => {
  const addressContext = useContext(AddressContext);
  const [address, setAddress] = useState({
    email: '',
    prefixNum: '',
    number: '',
    firstname: '',
    lastname: '',
    addressAdd: '',
    city: '',
    country: '',
    state: '',
    pincode: '',
  });

  const {
    email,
    firstname,
    lastname,
    prefixNum,
    number,
    addressAdd,
    city,
    country,
    state,
    pincode,
  } = address;

  const onChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    addressContext.addAddress(address);
    setAddress({
      email: '',
      prefixNum: '',
      number: '',
      firstname: '',
      lastname: '',
      addressAdd: '',
      city: '',
      country: '',
      state: '',
      pincode: '',
    });
  };
  return (
    <Container className='LiveThrowdown p-0' fluid>
      <TopNav />
      <ShippingAddressLogged />
      <Container className='text-light'>
        <h2 className='text-center'>Shipping Address</h2>

        <StyledBurger>
          <Row className='d-flex p-2'>
            <Col md={{ span: 8, offset: 4 }} className='p-2'>
              <form onSubmit={onSubmit}>
                <div className=' my-4'>
                  <div>
                    <label htmlFor=''>email</label>
                  </div>
                  <input
                    type='email'
                    name='email'
                    value={email}
                    onChange={onChange}
                    className='input_cust_styles'
                  />
                  <div className='my-2'>
                    <label className='cust_check-box'>
                      Keep me up to date on news and exclusive offers
                      <input type='checkbox' name='check' />
                      <span className='checkmark'></span>
                    </label>
                  </div>
                </div>

                <div className=' my-4'>
                  <div>
                    <label htmlFor=''>Contact Number</label>
                  </div>
                  <div className=''>
                    <select
                      name='prefixNum'
                      value={prefixNum}
                      onChange={onChange}
                      className='special-inp1 '
                    >
                      <option value='+91'>+91</option>
                      <option value='+1'>+1</option>
                      <option value='+7'>+7</option>
                      <option value='+61'>+61</option>
                    </select>
                    <input
                      type='text'
                      name='number'
                      value={number}
                      onChange={onChange}
                      className='text-light special-inp2 ml-3'
                    />
                  </div>
                </div>

                <div className='d-flex my-4'>
                  <div>
                    <div>
                      <label htmlFor=''>First name</label>
                    </div>
                    <input
                      type='text'
                      name='firstname'
                      value={firstname}
                      onChange={onChange}
                      className='input_inline'
                    />
                  </div>
                  <div>
                    <div>
                      <label htmlFor='' className='ml-4'>
                        Last name
                      </label>
                    </div>
                    <input
                      type='text'
                      name='lastname'
                      value={lastname}
                      onChange={onChange}
                      className='input_inline ml-4'
                    />
                  </div>
                </div>

                <div className='my-4'>
                  <div>
                    <label htmlFor=''>
                      Address (House no, Building, Street, Area)
                    </label>
                  </div>
                  <input
                    type='text'
                    name='addressAdd'
                    value={addressAdd}
                    onChange={onChange}
                    className='input_cust_styles'
                  />
                </div>

                <div className='my-4'>
                  <div>
                    <label htmlFor=''>city</label>
                  </div>
                  <input
                    type='text'
                    name='city'
                    value={city}
                    onChange={onChange}
                    className='input_cust_styles'
                  />
                </div>

                <div className='my-4'>
                  <div>
                    <label htmlFor='cars'>Country</label>
                  </div>
                  <select
                    name='country'
                    value={country}
                    onChange={onChange}
                    className='input_cust_styles'
                  >
                    <option value='United States'>United States</option>
                    <option value='saab'>Saab</option>
                    <option value='opel'>Opel</option>
                    <option value='audi'>Audi</option>
                  </select>
                </div>

                <div className='my-4'>
                  <div>
                    <label htmlFor='cars'>state</label>
                  </div>

                  <select
                    name='state'
                    value={state}
                    onChange={onChange}
                    id='state'
                    className='input_cust_styles'
                  >
                    <option value='Alabama'>Alabama</option>
                    <option value='saab'>Saab</option>
                    <option value='opel'>Opel</option>
                    <option value='audi'>Audi</option>
                  </select>
                </div>

                <div className='my-4'>
                  <div>
                    <div>Postal Code</div>
                    <input
                      type='text'
                      value={pincode}
                      onChange={onChange}
                      name='pincode'
                      className='input_cust_styles1'
                      placeholder='5220022'
                    />
                    <button
                      type='submit'
                      className='btn btn-theam input_cust_styles1 ml-3'
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </form>
            </Col>
          </Row>
        </StyledBurger>
      </Container>
    </Container>
  );
};
export default AddNewAddress;
